import { useState } from "react";
import { Modal, Select, List, Button } from "antd";
import { list, getUrl } from "aws-amplify/storage";

const documentTypes = [
  "All",
  "IFSP",
  "MD-Signature",
  "Initial-Assessment",
  "Initial-Arrows",
  "MHS",
  "Initial-Packet",
  "ICO",
  "Eligibility-Statement",
  "Annual-Paperwork",
  "Consent-Page",
  "Reports",
  "Referrals",
  "Other"
];

export default function DocumentFinderModal({ visible, onClose, record }) {
  const [docType, setDocType] = useState("");
  const [files, setFiles] = useState([]);

  const fetchFiles = async () => {
    if (!record?.firstStepsId || !docType) return;

    const prefix = docType === "All"
      ? `documents/${record.firstStepsId}/`
      : `documents/${record.firstStepsId}/${docType}/`

    const listed = await list({ prefix });

    console.log("list result:", listed);

    const filesArray = listed.items ?? [];

    const signed = await Promise.all(
      filesArray.map(async (file) => ({
        key: file.key,
        url: (await getUrl({ key: file.key })).url
      }))
    );

    setFiles(signed);
  };

  return (
    <Modal
      title={`Documents for ${record?.preferredName || ""} ${record?.lastName1}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Select
        placeholder="Select Document Type"
        value={docType}
        onChange={setDocType}
        options={documentTypes.map((d) => ({ label: d, value: d }))}
        style={{ width: "100%", marginBottom: 12 }}
      />

      <Button type="primary" onClick={fetchFiles} disabled={!docType}>
        Load Documents
      </Button>

      <List
        style={{ marginTop: 20 }}
        dataSource={files}
        renderItem={(item) => (
          <List.Item>
            <div>
              <strong>{item.key.split("/")[2]}</strong> — 
              <a href={item.url} target="_blank">{item.key.split("/").pop()}</a>
            </div>
          </List.Item>

        )}
      />
    </Modal>
  );
}
